import { lazy } from 'react';
import { AuthLayout } from '../components/AuthLayout';
import { routingPath } from '../../../app/routes/config';

const Login = lazy(() =>
  import('../pages/Login').then((m) => ({ default: m.Login })),
);
const NewPassword = lazy(() =>
  import('../pages/NewPassword').then((m) => ({ default: m.NewPassword })),
);
const PasswordRecovery = lazy(() =>
  import('../pages/PasswordRecovery').then((m) => ({
    default: m.PasswordRecovery,
  })),
);
const PasswordRecoveryConfirmation = lazy(() =>
  import('../pages/PasswordRecoveryConfirmation').then((m) => ({
    default: m.PasswordRecoveryConfirmation,
  })),
);
const TwoFactorAuth = lazy(() =>
  import('../pages/TwoFactorAuth').then((m) => ({ default: m.TwoFactorAuth })),
);
const EnableTwoFactorAuth = lazy(() =>
  import('../pages/EnableTwoFactorAuth').then((m) => ({
    default: m.EnableTwoFactorAuth,
  })),
);

const AuthRoutes = () => {
  return {
    element: <AuthLayout />,
    children: [
      {
        path: routingPath.auth.login,
        element: <Login />,
      },
      {
        path: routingPath.auth.newPassoword,
        element: <NewPassword />,
      },
      {
        path: routingPath.auth.passwordRecovery,
        element: <PasswordRecovery />,
      },
      {
        path: routingPath.auth.passwordRecoveryConfirmation,
        element: <PasswordRecoveryConfirmation />,
      },
      {
        path: routingPath.auth.twoFactor,
        element: <TwoFactorAuth />,
      },
      {
        path: routingPath.auth.enableTwoFactor,
        element: <EnableTwoFactorAuth />,
      },
    ],
  };
};

export default AuthRoutes;
